import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import { ShopVariables } from './types';

export type UseShopVariablesParams = {
  groupId: string;
};

export type ShopVariablesKey = readonly ['suppliers', string, 'shopVariables'];

export const getShopVariablesKey = (
  params: UseShopVariablesParams,
): ShopVariablesKey => ['suppliers', params.groupId, 'shopVariables'] as const;

export const useShopVariables: QueryFunction<
  ShopVariables,
  [UseShopVariablesParams],
  ShopVariablesKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getShopVariablesKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/shop_variables`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
